module.exports = __webpack_public_path__ + "img/wsgc.63ad30b5.png";